import React from 'react';

// reference: https://designportal.microsoft.com/media/?resetsearch=&field=metaproperty_Asset_Type&value=Illustrations&viewType=grid#
export const Badge = (props) => (
  <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M134.535 142.593C134.535 126.024 147.967 112.593 164.535 112.593H346.846C363.414 112.593 376.846 126.024 376.846 142.593V423.551C376.846 440.119 363.414 453.551 346.846 453.551H164.535C147.967 453.551 134.535 440.119 134.535 423.551V142.593Z"
      fill="url(#paint0_linear_5692_7417)" />
    <path
      d="M134.535 142.593C134.535 126.024 147.967 112.593 164.535 112.593H346.846C363.414 112.593 376.846 126.024 376.846 142.593V423.551C376.846 440.119 363.414 453.551 346.846 453.551H164.535C147.967 453.551 134.535 440.119 134.535 423.551V142.593Z"
      fill="url(#paint1_radial_5692_7417)" />
    <path
      d="M134.535 142.593C134.535 126.024 147.967 112.593 164.535 112.593H346.846C363.414 112.593 376.846 126.024 376.846 142.593V423.551C376.846 440.119 363.414 453.551 346.846 453.551H164.535C147.967 453.551 134.535 440.119 134.535 423.551V142.593Z"
      fill="url(#paint2_radial_5692_7417)" fillOpacity="0.6" />
    <path
      d="M134.535 142.593C134.535 126.024 147.967 112.593 164.535 112.593H346.846C363.414 112.593 376.846 126.024 376.846 142.593V423.551C376.846 440.119 363.414 453.551 346.846 453.551H164.535C147.967 453.551 134.535 440.119 134.535 423.551V142.593Z"
      fill="url(#paint3_radial_5692_7417)" fillOpacity="0.2" />
    <path
      d="M134.535 142.593C134.535 126.024 147.967 112.593 164.535 112.593H346.846C363.414 112.593 376.846 126.024 376.846 142.593V423.551C376.846 440.119 363.414 453.551 346.846 453.551H164.535C147.967 453.551 134.535 440.119 134.535 423.551V142.593Z"
      fill="url(#paint4_radial_5692_7417)" />
    <path
      d="M134.535 142.593C134.535 126.024 147.967 112.593 164.535 112.593H346.846C363.414 112.593 376.846 126.024 376.846 142.593V423.551C376.846 440.119 363.414 453.551 346.846 453.551H164.535C147.967 453.551 134.535 440.119 134.535 423.551V142.593Z"
      fill="url(#paint5_radial_5692_7417)" />
    <path
      d="M154.773 335.274C154.773 324.229 163.728 315.274 174.773 315.274H337.035C348.081 315.274 357.035 324.229 357.035 335.274V412.384C357.035 423.429 348.081 432.384 337.035 432.384H174.773C163.728 432.384 154.773 423.429 154.773 412.384V335.274Z"
      fill="url(#paint6_radial_5692_7417)" />
    <path
      d="M154.773 335.274C154.773 324.229 163.728 315.274 174.773 315.274H337.035C348.081 315.274 357.035 324.229 357.035 335.274V412.384C357.035 423.429 348.081 432.384 337.035 432.384H174.773C163.728 432.384 154.773 423.429 154.773 412.384V335.274Z"
      fill="url(#paint7_radial_5692_7417)" fillOpacity="0.7" />
    <path
      d="M154.773 335.274C154.773 324.229 163.728 315.274 174.773 315.274H337.035C348.081 315.274 357.035 324.229 357.035 335.274V412.384C357.035 423.429 348.081 432.384 337.035 432.384H174.773C163.728 432.384 154.773 423.429 154.773 412.384V335.274Z"
      fill="url(#paint8_radial_5692_7417)" fillOpacity="0.6" />
    <path
      d="M154.773 335.274C154.773 324.229 163.728 315.274 174.773 315.274H337.035C348.081 315.274 357.035 324.229 357.035 335.274V412.384C357.035 423.429 348.081 432.384 337.035 432.384H174.773C163.728 432.384 154.773 423.429 154.773 412.384V335.274Z"
      fill="url(#paint9_radial_5692_7417)" fillOpacity="0.8" />
    <path
      d="M154.773 335.274C154.773 324.229 163.728 315.274 174.773 315.274H337.035C348.081 315.274 357.035 324.229 357.035 335.274V412.384C357.035 423.429 348.081 432.384 337.035 432.384H174.773C163.728 432.384 154.773 423.429 154.773 412.384V335.274Z"
      fill="url(#paint10_radial_5692_7417)" fillOpacity="0.8" />
    <path
      d="M154.773 335.274C154.773 324.229 163.728 315.274 174.773 315.274H337.035C348.081 315.274 357.035 324.229 357.035 335.274V412.384C357.035 423.429 348.081 432.384 337.035 432.384H174.773C163.728 432.384 154.773 423.429 154.773 412.384V335.274Z"
      fill="url(#paint11_radial_5692_7417)" fillOpacity="0.6" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M174.773 313.274H337.035C349.185 313.274 359.035 323.124 359.035 335.274V412.384C359.035 424.534 349.185 434.384 337.035 434.384H174.773C162.623 434.384 152.773 424.534 152.773 412.384V335.274C152.773 323.124 162.623 313.274 174.773 313.274ZM174.773 315.274C163.728 315.274 154.773 324.229 154.773 335.274V412.384C154.773 423.429 163.728 432.384 174.773 432.384H337.035C348.081 432.384 357.035 423.429 357.035 412.384V335.274C357.035 324.229 348.081 315.274 337.035 315.274H174.773Z"
      fill="#F2F1F3" />
    <rect x="267.719" y="58.0439" width="43.4789" height="97.8484" rx="5"
      transform="rotate(23.4437 267.719 58.0439)" fill="url(#paint12_linear_5692_7417)" />
    <rect x="267.719" y="58.0439" width="43.4789" height="97.8484" rx="5"
      transform="rotate(23.4437 267.719 58.0439)" fill="url(#paint13_radial_5692_7417)"
      fillOpacity="0.55" />
    <rect x="267.719" y="58.0439" width="43.4789" height="97.8484" rx="5"
      transform="rotate(23.4437 267.719 58.0439)" fill="url(#paint14_radial_5692_7417)"
      fillOpacity="0.45" />
    <rect x="267.719" y="58.0439" width="43.4789" height="97.8484" rx="5"
      transform="rotate(23.4437 267.719 58.0439)" fill="url(#paint15_radial_5692_7417)"
      fillOpacity="0.45" />
    <rect x="267.719" y="58.0439" width="43.4789" height="97.8484" rx="5"
      transform="rotate(23.4437 267.719 58.0439)" fill="url(#paint16_radial_5692_7417)"
      fillOpacity="0.75" />
    <circle cx="257.303" cy="133.721" r="11.6976" fill="url(#paint17_radial_5692_7417)" />
    <circle cx="257.303" cy="133.721" r="11.6976" fill="url(#paint18_radial_5692_7417)"
      fillOpacity="0.45" />
    <path
      d="M310.844 359.878C310.844 366.635 305.366 372.113 298.608 372.113L213.476 372.113C206.718 372.113 201.24 366.635 201.24 359.878C201.24 353.12 206.718 347.642 213.476 347.642L298.608 347.642C305.366 347.642 310.844 353.12 310.844 359.878Z"
      fill="url(#paint19_linear_5692_7417)" />
    <path
      d="M310.844 359.878C310.844 366.635 305.366 372.113 298.608 372.113L213.476 372.113C206.718 372.113 201.24 366.635 201.24 359.878C201.24 353.12 206.718 347.642 213.476 347.642L298.608 347.642C305.366 347.642 310.844 353.12 310.844 359.878Z"
      fill="url(#paint20_radial_5692_7417)" />
    <path
      d="M310.844 359.878C310.844 366.635 305.366 372.113 298.608 372.113L213.476 372.113C206.718 372.113 201.24 366.635 201.24 359.878C201.24 353.12 206.718 347.642 213.476 347.642L298.608 347.642C305.366 347.642 310.844 353.12 310.844 359.878Z"
      fill="url(#paint21_radial_5692_7417)" fillOpacity="0.6" />
    <path
      d="M310.844 359.878C310.844 366.635 305.366 372.113 298.608 372.113L213.476 372.113C206.718 372.113 201.24 366.635 201.24 359.878C201.24 353.12 206.718 347.642 213.476 347.642L298.608 347.642C305.366 347.642 310.844 353.12 310.844 359.878Z"
      fill="url(#paint22_radial_5692_7417)" fillOpacity="0.5" />
    <path
      d="M280.004 396.686C280.004 403.444 274.526 408.922 267.768 408.922L243.915 408.922C237.158 408.922 231.68 403.444 231.68 396.686C231.68 389.929 237.158 384.451 243.915 384.451L267.768 384.451C274.526 384.451 280.004 389.929 280.004 396.686Z"
      fill="url(#paint23_linear_5692_7417)" />
    <path
      d="M280.004 396.686C280.004 403.444 274.526 408.922 267.768 408.922L243.915 408.922C237.158 408.922 231.68 403.444 231.68 396.686C231.68 389.929 237.158 384.451 243.915 384.451L267.768 384.451C274.526 384.451 280.004 389.929 280.004 396.686Z"
      fill="url(#paint24_radial_5692_7417)" />
    <path
      d="M280.004 396.686C280.004 403.444 274.526 408.922 267.768 408.922L243.915 408.922C237.158 408.922 231.68 403.444 231.68 396.686C231.68 389.929 237.158 384.451 243.915 384.451L267.768 384.451C274.526 384.451 280.004 389.929 280.004 396.686Z"
      fill="url(#paint25_radial_5692_7417)" fillOpacity="0.6" />
    <path
      d="M280.004 396.686C280.004 403.444 274.526 408.922 267.768 408.922L243.915 408.922C237.158 408.922 231.68 403.444 231.68 396.686C231.68 389.929 237.158 384.451 243.915 384.451L267.768 384.451C274.526 384.451 280.004 389.929 280.004 396.686Z"
      fill="url(#paint26_radial_5692_7417)" fillOpacity="0.5" />
    <path
      d="M255.354 294.624C287.699 294.624 313.919 268.404 313.919 236.059C313.919 203.715 287.699 177.494 255.354 177.494C223.01 177.494 196.789 203.715 196.789 236.059C196.789 268.404 223.01 294.624 255.354 294.624Z"
      fill="url(#paint27_radial_5692_7417)" />
    <path
      d="M255.354 294.624C287.699 294.624 313.919 268.404 313.919 236.059C313.919 203.715 287.699 177.494 255.354 177.494C223.01 177.494 196.789 203.715 196.789 236.059C196.789 268.404 223.01 294.624 255.354 294.624Z"
      fill="url(#paint28_radial_5692_7417)" fillOpacity="0.6" />
    <path
      d="M255.354 294.624C287.699 294.624 313.919 268.404 313.919 236.059C313.919 203.715 287.699 177.494 255.354 177.494C223.01 177.494 196.789 203.715 196.789 236.059C196.789 268.404 223.01 294.624 255.354 294.624Z"
      fill="url(#paint29_radial_5692_7417)" fillOpacity="0.5" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M255.354 291.624C286.042 291.624 310.919 266.747 310.919 236.059C310.919 205.371 286.042 180.494 255.354 180.494C224.666 180.494 199.789 205.371 199.789 236.059C199.789 266.747 224.666 291.624 255.354 291.624ZM313.919 236.059C313.919 268.404 287.699 294.624 255.354 294.624C223.01 294.624 196.789 268.404 196.789 236.059C196.789 203.715 223.01 177.494 255.354 177.494C287.699 177.494 313.919 203.715 313.919 236.059Z"
      fill="url(#paint30_radial_5692_7417)" />
    <path
      d="M271.055 79.9805C271.055 80.6417 270.519 81.1777 269.857 81.1777C269.196 81.1777 268.66 80.6417 268.66 79.9805C268.66 79.3192 269.196 78.7832 269.857 78.7832C270.519 78.7832 271.055 79.3192 271.055 79.9805Z"
      fill="#FEE39E" />
    <path
      d="M282.76 117.608C283.421 117.608 283.957 117.072 283.957 116.411C283.957 115.749 283.421 115.213 282.76 115.213C282.099 115.213 281.562 115.749 281.562 116.411C281.562 117.072 282.099 117.608 282.76 117.608Z"
      fill="#FEE39E" />
    <path
      d="M242.312 131.41C243.185 131.41 243.893 130.702 243.893 129.829C243.893 128.955 243.185 128.247 242.312 128.247C241.439 128.247 240.73 128.955 240.73 129.829C240.73 130.702 241.439 131.41 242.312 131.41Z"
      fill="#FEE39E" />
    <path
      d="M259.665 82.1845C260.081 82.3608 260.692 81.8584 261.029 81.0623C261.367 80.2662 261.303 79.478 260.886 79.3017C260.47 79.1254 259.859 79.6279 259.522 80.4239C259.185 81.22 259.249 82.0082 259.665 82.1845Z"
      fill="#FEE39E" />
    <path
      d="M276.594 101.231C276.594 101.893 276.058 102.429 275.396 102.429C274.735 102.429 274.199 101.893 274.199 101.231C274.199 100.57 274.735 100.034 275.396 100.034C276.058 100.034 276.594 100.57 276.594 101.231Z"
      fill="#FEE39E" />
    <path
      d="M292.473 88.9571C293.134 88.9571 293.67 88.4211 293.67 87.7598C293.67 87.0986 293.134 86.5626 292.473 86.5626C291.811 86.5626 291.275 87.0986 291.275 87.7598C291.275 88.4211 291.811 88.9571 292.473 88.9571Z"
      fill="#FEE39E" />
    <path
      d="M277.412 105.217C277.412 105.669 277.046 106.035 276.594 106.035C276.142 106.035 275.775 105.669 275.775 105.217C275.775 104.765 276.142 104.398 276.594 104.398C277.046 104.398 277.412 104.765 277.412 105.217Z"
      fill="#FEE39E" />
    <path
      d="M250.65 152.402C251.286 152.402 251.801 151.887 251.801 151.252C251.801 150.616 251.286 150.101 250.65 150.101C250.015 150.101 249.5 150.616 249.5 151.252C249.5 151.887 250.015 152.402 250.65 152.402Z"
      fill="#FEE39E" />
    <path
      d="M281.067 247.438C281.067 259.017 271.68 268.404 260.101 268.404L250.607 268.404C239.028 268.404 229.641 259.017 229.641 247.438C229.641 244.543 231.988 242.196 234.883 242.196L275.826 242.196C278.72 242.196 281.067 244.543 281.067 247.438Z"
      fill="url(#paint31_radial_5692_7417)" />
    <path
      d="M281.067 247.438C281.067 259.017 271.68 268.404 260.101 268.404L250.607 268.404C239.028 268.404 229.641 259.017 229.641 247.438C229.641 244.543 231.988 242.196 234.883 242.196L275.826 242.196C278.72 242.196 281.067 244.543 281.067 247.438Z"
      fill="url(#paint32_radial_5692_7417)" />
    <path
      d="M281.067 247.438C281.067 259.017 271.68 268.404 260.101 268.404L250.607 268.404C239.028 268.404 229.641 259.017 229.641 247.438C229.641 244.543 231.988 242.196 234.883 242.196L275.826 242.196C278.72 242.196 281.067 244.543 281.067 247.438Z"
      fill="url(#paint33_radial_5692_7417)" />
    <path
      d="M270.844 219.856C270.844 228.411 263.909 235.346 255.354 235.346C246.799 235.346 239.864 228.411 239.864 219.856C239.864 211.301 246.799 204.366 255.354 204.366C263.909 204.366 270.844 211.301 270.844 219.856Z"
      fill="url(#paint34_radial_5692_7417)" />
    <path
      d="M270.844 219.856C270.844 228.411 263.909 235.346 255.354 235.346C246.799 235.346 239.864 228.411 239.864 219.856C239.864 211.301 246.799 204.366 255.354 204.366C263.909 204.366 270.844 211.301 270.844 219.856Z"
      fill="url(#paint35_radial_5692_7417)" />
    <defs>
      <linearGradient id="paint0_linear_5692_7417" x1="362.16" y1="91.0132" x2="-47.841" y2="532.098"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.367698" stopColor="#E7E7E7" />
        <stop offset="0.788937" stopColor="#C5B4E3" />
      </linearGradient>
      <radialGradient id="paint1_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(249 248) rotate(48.145) scale(64.4438 67.1722)">
        <stop offset="0.872875" stopColor="#D0D0D0" />
        <stop offset="1" stopColor="#E4E4E4" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint2_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(255.69 418.279) rotate(0.370983) scale(111.312 37.1559)">
        <stop offset="0.703245" stopColor="#AFA1BB" />
        <stop offset="1" stopColor="#E4E4E4" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint3_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(250.693 150.312) rotate(24.8874) scale(24.2242 14.9044)">
        <stop offset="0.744792" stopColor="#666169" />
        <stop offset="1" stopColor="#666169" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint4_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(255.69 112.593) scale(240.31 47.4072)">
        <stop offset="0.417926" stopColor="#D0D0D0" />
        <stop offset="0.674926" stopColor="#E8E8E8" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint5_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(401.638 270.718) rotate(180) scale(134.721 751.096)">
        <stop offset="0.173611" stopColor="#D0D0D0" />
        <stop offset="0.458333" stopColor="#E7E4EC" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint6_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(214 338) rotate(71.1818) scale(189.108 399.618)">
        <stop offset="0.381908" stopColor="#FFD337" />
        <stop offset="0.515548" stopColor="#FF9920" />
      </radialGradient>
      <radialGradient id="paint7_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(357.035 445) rotate(-131.979) scale(95.7382 178.81)">
        <stop offset="0.761214" stopColor="#FF74C8" />
        <stop offset="1" stopColor="#ED9BB0" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint8_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(366 373.829) rotate(-180) scale(35 162.374)">
        <stop offset="0.189656" stopColor="#C42D39" />
        <stop offset="1" stopColor="#FE818B" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint9_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(258.831 367.424) rotate(-180) scale(74.9425 17.5061)">
        <stop offset="0.631521" stopColor="#C58200" />
        <stop offset="0.873062" stopColor="#FFD438" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint10_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(255.904 403.934) rotate(90) scale(15.1326 26.1358)">
        <stop offset="0.723958" stopColor="#C58200" />
        <stop offset="1" stopColor="#FFB92D" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint11_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(255.904 315.274) rotate(90) scale(29.7256 137.904)">
        <stop offset="0.562666" stopColor="#C58200" />
        <stop offset="1" stopColor="#FFD438" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="paint12_linear_5692_7417" x1="288.781" y1="92.8712" x2="290.023"
        y2="193.378" gradientUnits="userSpaceOnUse">
        <stop stopColor="#42BEFF" />
        <stop offset="1" stopColor="#518ADF" />
      </linearGradient>
      <radialGradient id="paint13_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(321.439 180.717) rotate(-169.396) scale(78.1536 30.469)">
        <stop offset="0.744792" stopColor="#3C60BE" />
        <stop offset="1" stopColor="#3C60BE" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint14_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(288.531 55.4822) rotate(179.13) scale(52.2251 23.2062)">
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint15_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(314.051 106.399) rotate(93.3935) scale(93.4343 15.642)">
        <stop offset="0.208333" stopColor="#2B5DBF" />
        <stop offset="1" stopColor="#64AFDF" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint16_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(289.102 133.259) rotate(85.9304) scale(13.3164 12.6274)">
        <stop offset="0.651042" stopColor="#17517D" />
        <stop offset="0.848958" stopColor="#13588D" stopOpacity="0.820896" />
        <stop offset="1" stopColor="#0078D4" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint17_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(257.305 130) rotate(90) scale(17.75 16.1843)">
        <stop offset="0.690141" stopColor="#E9D4BE" />
        <stop offset="1" stopColor="#A8937B" />
      </radialGradient>
      <radialGradient id="paint18_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(257.303 137.128) rotate(90) scale(19.2796 16.985)">
        <stop offset="0.671875" stopColor="white" stopOpacity="0" />
        <stop offset="0.734375" stopColor="white" />
      </radialGradient>
      <linearGradient id="paint19_linear_5692_7417" x1="280.416" y1="347.642" x2="280.416"
        y2="377.466" gradientUnits="userSpaceOnUse">
        <stop offset="0.0572917" stopColor="#FDF0DC" />
        <stop offset="0.375" stopColor="#E4D2BC" />
        <stop offset="0.728652" stopColor="#B59E8D" />
        <stop offset="0.93407" stopColor="#E4D2BC" />
      </linearGradient>
      <radialGradient id="paint20_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(256.042 354.143) rotate(179.628) scale(58.8394 28.2343)">
        <stop offset="0.810616" stopColor="#B59E8D" stopOpacity="0" />
        <stop offset="0.972643" stopColor="#B59E8D" />
      </radialGradient>
      <radialGradient id="paint21_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(256.042 351.084) rotate(-90) scale(13.7648 65.9794)">
        <stop stopColor="white" />
        <stop offset="0.659918" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint22_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(256.973 352.422) rotate(-90) scale(11.2795 135.219)">
        <stop stopColor="white" />
        <stop offset="0.295449" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="paint23_linear_5692_7417" x1="266.588" y1="384.451" x2="266.588"
        y2="414.275" gradientUnits="userSpaceOnUse">
        <stop offset="0.0572917" stopColor="#FDF0DC" />
        <stop offset="0.375" stopColor="#E4D2BC" />
        <stop offset="0.728652" stopColor="#B59E8D" />
        <stop offset="0.93407" stopColor="#E4D2BC" />
      </linearGradient>
      <radialGradient id="paint24_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(255.842 391) rotate(-180) scale(28.3418 22.2305)">
        <stop offset="0.680847" stopColor="#B59E8D" stopOpacity="0" />
        <stop offset="0.972643" stopColor="#B59E8D" />
      </radialGradient>
      <radialGradient id="paint25_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(255.842 387.892) rotate(-90) scale(13.7648 29.0904)">
        <stop stopColor="white" />
        <stop offset="0.659918" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint26_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(256.252 389.231) rotate(-90) scale(11.2795 59.6181)">
        <stop stopColor="white" />
        <stop offset="0.295449" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint27_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(300 294.624) rotate(-121.383) scale(167.065)">
        <stop offset="0.150012" stopColor="#45B8FC" />
        <stop offset="0.421554" stopColor="#BB7DFF" />
      </radialGradient>
      <radialGradient id="paint28_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(252.264 225.078) rotate(110.171) scale(17.9132)">
        <stop offset="0.78" stopColor="#25126A" />
        <stop offset="1" stopColor="#BC7EFF" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint29_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(252.75 258.75) rotate(-85.9717) scale(17.794 28.1262)">
        <stop offset="0.8" stopColor="#25126A" />
        <stop offset="1" stopColor="#BC7EFF" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint30_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(300 294.624) rotate(-121.383) scale(167.065)">
        <stop offset="0.150012" stopColor="#17A9FF" />
        <stop offset="0.421554" stopColor="#CFA3FF" />
      </radialGradient>
      <radialGradient id="paint31_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(281.067 238.253) rotate(120.941) scale(36.502 45.6193)">
        <stop stopColor="#F2F0EE" />
        <stop offset="0.410349" stopColor="#E8DFD2" />
        <stop offset="1" stopColor="#DDCFBC" />
      </radialGradient>
      <radialGradient id="paint32_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(258.358 247.6) rotate(173.643) scale(116.859 85.9347)">
        <stop offset="0.198166" stopColor="#E1D3C2" stopOpacity="0" />
        <stop offset="0.234775" stopColor="#C0AD92" />
      </radialGradient>
      <radialGradient id="paint33_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(258.358 242.196) scale(52.0291 5.17849)">
        <stop offset="0.186147" stopColor="#FBF2EB" />
        <stop offset="0.770563" stopColor="#FBF2EB" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="paint34_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(260.691 207.296) rotate(116.565) scale(29.1693 29.1693)">
        <stop stopColor="#F2F0EE" />
        <stop offset="0.410349" stopColor="#E8DFD2" />
        <stop offset="1" stopColor="#DDCFBC" />
      </radialGradient>
      <radialGradient id="paint35_radial_5692_7417" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(256.78 218.545) rotate(-4.18538) scale(66.9091 65.2272)">
        <stop offset="0.199595" stopColor="#EBDFD5" stopOpacity="0" />
        <stop offset="0.241807" stopColor="#C0AD92" />
      </radialGradient>
    </defs>
  </svg>
);

Badge.displayName = 'Badge';
